import type { FrontendInstaller } from "@p0security/integrations-installer";
import type { ItemComponent } from "@p0security/shared/install/types";

export const scimInstaller: FrontendInstaller<{ scim: ItemComponent<any> }> = {
  components: { scim: { items: {} } },
};
